import React, { useState, useEffect, useCallback } from 'react';
import { firestoreConnect } from 'react-redux-firebase';
import { compose } from 'redux';
import ReactPaginate from 'react-paginate';

function Pagination(props) {
  const { limitPerPage, marginPagesDisplayed, pageRangeDisplayed, completeList, setCurrentList } = props;
  const [currentPage, setCurrentPage] = useState(0);

  const initLoading = () => {
    handlePageClick({ selected: currentPage });
  };

  const handlePageClick = useCallback((data) => {
    let selected = data.selected;
    let offset = Math.ceil(selected * limitPerPage);
    offset = offset === completeList.length && selected !== 0 ? Math.ceil((selected - 1) * limitPerPage) : offset;
    const currentList = completeList.slice(offset, offset + limitPerPage);
    setCurrentPage(selected);
    setCurrentList(currentList);
  }, [completeList, limitPerPage, setCurrentList]);
  
  useEffect(initLoading, [completeList, currentPage, handlePageClick]);

  const completeListCount = completeList.length;
  if (completeListCount === 0) return null;
  const totalPages = Math.ceil(completeListCount / limitPerPage);

  return (
    <ReactPaginate
      previousLabel={'Previous'}
      nextLabel={'Next'}
      breakLabel={'...'}
      breakClassName={'break-me'}
      pageCount={totalPages}
      marginPagesDisplayed={marginPagesDisplayed}
      pageRangeDisplayed={pageRangeDisplayed}
      onPageChange={handlePageClick}
      containerClassName={'pagination'}
      subContainerClassName={'pages pagination'}
      activeClassName={'active'}
    />
  );
}

export default compose(firestoreConnect())(Pagination);
